/**
 * Created by Mikhail Menshenin on 10.07.2024
 */

ToolbarItem.GALLERY = {
    type: 19,
    icon: bundles.toolbar.frames.toolbar_gallery_png
};

ToolbarItem.MINIGAME_BONUS.title = "MiniGameWindow.Title";
ToolbarItem.WEEKLY_GOALS.title = "WeeklyGoalsWindow.title";
